import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Request} from '../../../requests/shared/model/request.model';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map, mergeMap} from 'rxjs/operators';

@Injectable()
export class CustomerFromRequestResolver implements Resolve<Observable<Request>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Request> {
    const requestId = route.queryParams['r'];
    if (requestId) {
      return this.facadeService.getRequestById(+requestId).pipe(
        mergeMap((request: Request) => {
          return this.facadeService.getCustomerById(+request.customerId).pipe(
            map((data) => data),
            catchError(error => {
              return of({error: error});
            })
          );
        })
      );
    }
  }
}
